import { Component, OnInit, Optional } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { IndexedService } from '@damofire/data-commons';
import { AUTH_PATHS, AuthenticationService, IdbAuthStoreService } from '@damofire/data-security';
import { TranslatePipe } from '@ngx-translate/core';
import { LoaderComponent } from '../loader/loader.component';

@Component({
  templateUrl: './logout.component.html',
  standalone: true,
  imports: [LoaderComponent, TranslatePipe],
})
export class LogoutComponent implements OnInit {
  constructor(
    private readonly auth: Auth,
    private readonly router: Router,
    private readonly authService: AuthenticationService,
    @Optional() private readonly idbService?: IndexedService,
    @Optional() private readonly idbAuthStoreService?: IdbAuthStoreService,
  ) {}

  ngOnInit(): void {
    this.logout().catch(console.error);
  }

  private async logout(): Promise<void> {
    await this.auth.signOut();
    this.authService.reset();
    await this.clean();
    await this.router.navigateByUrl(AUTH_PATHS.SIGN_IN);
  }

  private async clean(): Promise<void> {
    localStorage.clear();
    console.log('Cleared localStorage');
    sessionStorage.clear();
    console.log('Cleared sessionStorage');

    await this.idbService?.clear().catch((err) => console.warn('Warning clearing idb:', err));
    await this.idbAuthStoreService?.clear().catch((err) => console.warn('Warning clearing idbAuth:', err));
    await new Promise((r) => setTimeout(r, 300)); // small delay helps Safari chill
  }
}
